module.exports = __webpack_public_path__ + "static/media/bgDefaultCoursesMobileDay.b3e40b23.jpg";